import { BackgroundShading } from '@/shared/ui/backgroundShading'
import { useStyles } from './styles'
import { Skeleton } from '@mui/material'
import { useUnit } from 'effector-react'
import { $userLanguage } from '@/entities/user'
import { lang } from '@/shared/constants/lang'

export const ExternalProfileSkeleton = () => {
  const { classes } = useStyles()
  const userLang = useUnit($userLanguage)
  const texts = lang[userLang].pages.profile

  return (
    <div className={classes.root}>
      <div className={classes.header}>
        <img
          src="/assets/subscriptionRelated/gamedLogo.webp"
          className={classes.logoImg}
        />
        <BackgroundShading
          bottom="0"
          height="112px"
        />
      </div>
      <div className={classes.content}>
        <Skeleton
          width={'100%'}
          height={182}
        />
        <h1 className={classes.title}>{texts.externalGamingLegacy}</h1>
        <div className={classes.stats}>
          {Array.from({ length: 8 }).map((_, index) => (
            <Skeleton
              key={index}
              width={'100%'}
              height={128}
            />
          ))}
        </div>
        <h1 className={classes.title}>{texts.favoriteGames}</h1>
        <div style={{ display: 'flex', flexDirection: 'column', gap: '12px', width: '100%' }}>
          {Array.from({ length: 5 }).map((_, index) => (
            <Skeleton
              key={index}
              width={'100%'}
              height={80}
            />
          ))}
        </div>
      </div>
    </div>
  )
}
